"use client";

import { sendGTMEvent } from "@next/third-parties/google";

import type { ProductDataLayerType } from "./types";
import { GTagEvents, valueFormatter } from "./types";

type PurchaseProps = {
  orderId: string;
  value: number;
  shipping: string;
  tax: number;
  currency: string;
  items: ProductDataLayerType[];
  coupon?: string;
};

export const purchaseEvent = ({
  orderId,
  value,
  currency,
  items,
  coupon,
  shipping,
  tax,
}: PurchaseProps) => {
  console.log({
    event: GTagEvents.PURCHASE,
    currency,
    transaction_id: orderId,
    value,
    items,
    coupon,
    shipping: valueFormatter(shipping),
    tax,
  });

  sendGTMEvent({
    event: GTagEvents.PURCHASE,
    currency,
    transaction_id: orderId,
    value,
    items,
    coupon,
    shipping: valueFormatter(shipping),
    tax,
  });
};
